module.exports = __webpack_public_path__ + "static/media/dong_dice.5c9e2abf.png";